import React from "react";
import { cva, VariantProps } from "class-variance-authority";
import clsx from "clsx";

import CompanyLogo, { CompanyLogoProps } from "@/components/molecules/company/CompanyLogo";

const stackSpacingVariants = cva("flex overflow-hidden", {
  variants: {
    spacing: {
      xs: "-space-x-2",
      sm: "-space-x-2",
      md: "-space-x-2",
      lg: "-space-x-3",
      xl: "-space-x-4",
      "2xl": "-space-x-6",
      "3xl": "-space-x-10",
      "4xl": "-space-x-16",
    },
  },
  defaultVariants: {
    spacing: "md",
  },
});

type CompanyLogoStackProps = React.HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof stackSpacingVariants> & {
    imageUrls: CompanyLogoProps["url"][];
    className?: string;
  };

const CompanyLogoStack = ({ spacing, imageUrls, className }: CompanyLogoStackProps) => {
  return (
    <div className={clsx(className, stackSpacingVariants({ spacing }))}>
      {imageUrls.map((imageUrl, index) => (
        <CompanyLogo url={imageUrl} key={index} />
      ))}
    </div>
  );
};

export default CompanyLogoStack;
